import { ORDER_TYPES } from '@/constants/orderTypes'
import { PAYMENT_TYPES } from '@/constants/paymentTypes'
import { STATUSES } from '@/constants/statuses'

export const PRINT_ORDER_STATUS = {
    QUEUED: 'queued',
    SUCCESS: 'success',
    ERROR: 'error',
}

// Причина ответа /orders/print: во всех позициях выбранных заказов стоит запрет на печать
export const PRINT_REASON_NO_UNPRINTED_DISHES = 'no_unprinted_dishes'

export const PRINT_GROUPS_STORAGE_KEY = 'dispatcher_print_groups'

// Время жизни группы печати (5 минут)
export const PRINT_GROUP_TTL_MS = 5 * 60 * 1000

export const PRINT_STATUS_DELAY_MS = 300
export const PRINT_GROUP_RESYNC_TIMEOUT_MS = 30 * 1000
export const PRINT_GROUP_RESYNC_CHECK_MS = 1000

export const FORBIDDEN_STATUSES_FOR_PRINT = [
    STATUSES.SEND_ERROR,
    STATUSES.CANCELED_BY_MANAGER,
    STATUSES.CANCELED,
    STATUSES.SENT_TO_DIVISION,
]

export const FORBIDDEN_STATUSES_FOR_THERMO = [
    STATUSES.SENT_TO_DIVISION,
    STATUSES.SEND_ERROR,
    STATUSES.CANCELED,
    STATUSES.CANCELED_BY_MANAGER,
    STATUSES.DELIVERED,
    STATUSES.COMPLETED,
]

export const FORBIDDEN_STATUSES_FOR_FISCAL = [
    ...FORBIDDEN_STATUSES_FOR_PRINT,
    STATUSES.WAITING_START_COOKING,
]

export const FORBIDDEN_PRINT_FISCAL_PAYMENT_TYPES = [
    PAYMENT_TYPES.ONLINE,
    PAYMENT_TYPES.ONLINE_CHANGE,
    PAYMENT_TYPES.ONLINE_TRANSACTION,
    PAYMENT_TYPES.INVOICE_BOX,
    PAYMENT_TYPES.GIFT_CARD,
    PAYMENT_TYPES.SBP_COURIER,
    PAYMENT_TYPES.PAYMENT_UNDER_CONTRACT,
    PAYMENT_TYPES.PREORDER,
    PAYMENT_TYPES.STAFF,
]

export const ALLOWED_PRINT_FISCAL_PAYMENT_TYPES = [
    PAYMENT_TYPES.CASH,
    PAYMENT_TYPES.TERMINAL_RESTAURANT,
    PAYMENT_TYPES.RESTAURANT,
]

export const ALLOWED_PRINT_FISCAL_ORDER_TYPES = [ORDER_TYPES.SELF]
